<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_insole') }}
      </h3>
      <hr />
    </div>
    <template v-for="(section, index) in sections">
      <div :key="section.matKey" class="columns">
        <div class="column is-8">
          <div class="columns">
            <div class="column">
              <b-field
                :type="{ 'is-danger': errors.has(section.matKey + suffix) }"
                :label="$translate(section.matKey) | capitalize"
                :message="errors.first(section.matKey + suffix)"
              >
                <b-select
                  v-model="local[section.matKey]"
                  v-validate="section.matRequired ? 'required' : ''"
                  :name="section.matKey + suffix"
                  :disabled="disabledbool"
                  :placeholder="$translate('placeholder_select')"
                  @input="onChangeMat(section, $event)"
                >
                  <option
                    v-for="mat in section.available"
                    :key="mat.id"
                    :value="mat.id"
                    :label="$translateMaterial(mat)"
                  >
                    {{ $translateMaterial(mat) }}
                  </option>
                </b-select>
              </b-field>
              <b-field
                v-show="local[section.matKey] != null"
                :type="{ 'is-danger': errors.has(section.varKey + suffix) }"
                :label="$translate(section.varKey) | capitalize"
                :message="errors.first(section.varKey + suffix)"
              >
                <b-select
                  v-model="local[section.varKey]"
                  v-validate="local[section.matKey] ? 'required' : ''"
                  :name="section.varKey + suffix"
                  :disabled="disabledbool"
                  :placeholder="$translate('placeholder_select')"
                  @input="onChange(section.varKey, $event)"
                >
                  <template v-for="mat in section.available">
                    <template v-if="mat.id === local[section.matKey]">
                      <option v-for="matVar in mat.variants" :key="matVar.id" :value="matVar.id">
                        {{ $translateMaterialVariant(matVar) }}
                      </option>
                    </template>
                  </template>
                </b-select>
              </b-field>
            </div>
            <div class="column has-text-centered image-cell">
              <img v-if="imageFor(section)" :src="imageFor(section)" style="max-width: 150px; max-height: 150px;" />
            </div>
          </div>
        </div>
      </div>
      <hr v-if="index < sections.length - 1" :key="`${section.matKey}-hr`" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'Insole',
  props: [
    'orderbool',
    'mod',
    'availableInsoleBase',
    'availableInsoleCover',
    'availableInsoleFill',
    'disabledbool',
    'orderInfoMandatory',
    'hideCover',
    'nameSuffix',
  ],
  data() {
    return {
      local: {
        insoleBaseMat: null,
        insoleBaseVar: null,
        insoleCoverMat: null,
        insoleCoverVar: null,
        insoleFillMat: null,
        insoleFillVar: null,
      },
    }
  },
  computed: {
    suffix() {
      return this.nameSuffix ? this.nameSuffix : ''
    },
    sections() {
      const sections = [
        {
          matKey: 'insoleBaseMat',
          varKey: 'insoleBaseVar',
          available: this.availableInsoleBase,
          matRequired: true,
        },
        {
          matKey: 'insoleCoverMat',
          varKey: 'insoleCoverVar',
          available: this.availableInsoleCover,
          matRequired: false,
        },
        {
          matKey: 'insoleFillMat',
          varKey: 'insoleFillVar',
          available: this.availableInsoleFill,
          matRequired: false,
        },
      ]
      return this.hideCover ? sections.filter(section => section.matKey !== 'insoleCoverMat') : sections
    },
  },
  inject: ['$validator'],

  watch: {
    mod() {
      this.updateAfterload()
    },
    hideCover(val) {
      if (val) {
        this.clearCover()
      }
    },
  },
  mounted() {
    this.updateAfterload()
  },
  methods: {
    updateAfterload() {
      if (!this.mod) return
      this.sections.forEach(section => {
        this.local[section.matKey] = this.mod[section.matKey] != null ? this.mod[section.matKey] : null
        this.local[section.varKey] = this.mod[section.varKey] != null ? this.mod[section.varKey] : null
      })
      if (this.hideCover) {
        this.clearCover()
      }
    },
    clearCover() {
      this.local.insoleCoverMat = null
      this.local.insoleCoverVar = null
      if (this.mod && (this.mod.insoleCoverMat != null || this.mod.insoleCoverVar != null)) {
        this.$emit('onChangeMat', { key: 'insoleCoverMat', value: null })
        this.$emit('onChangeMat', { key: 'insoleCoverVar', value: null })
      }
    },
    imageFor(section) {
      const mat = (section.available || []).find(m => m.id === this.local[section.matKey])
      if (mat && mat.variants) {
        const variant = mat.variants.find(v => v.id === this.local[section.varKey])
        return variant ? variant.image : ''
      }
      return ''
    },
    onChangeMat(section, id) {
      this.local[section.varKey] = null
      this.$emit('onChangeMat', { key: section.matKey, value: id })
      this.$emit('onChangeMat', { key: section.varKey, value: null })
    },
    onChange(name, id) {
      this.$emit('onChangeMat', { key: name, value: id })
    },
  },
}
</script>
<style scoped>
.container >>> .field-label {
  text-align: left;
}
.image-cell {
  padding-top: 2em;
}
.select-is-large >>> select {
  min-width: 300px;
  min-height: 300px;
  overflow-x: auto;
}
.multiselect-list {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  min-width: 300px;
  min-height: 120px;
  max-height: 200px;
  overflow-y: auto;
  background: white;
}
.multiselect-list.is-disabled {
  background-color: #f5f5f5;
  pointer-events: none;
}
.multiselect-option {
  padding: 0.35rem 0.75rem;
  white-space: normal;
  cursor: pointer;
  line-height: 1.4;
}
.multiselect-option:hover {
  background-color: #f5f5f5;
}
.multiselect-option.is-selected {
  background-color: #3273dc;
  color: white;
}
.multiselect-placeholder {
  display: block;
  padding: 0.35rem 0.75rem;
}
</style>
